import jss from 'jss';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    minHeight: '100%'
  },
  treeContainer: {
    maxWidth: '15vw',
    width: 300,
    padding: '15px 0',
    minHeight: '100%',
    overflowX: 'hidden',
    overflowY: 'scroll'
  },
  treeActionsContainer: {
    paddingLeft: 5,
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 15,
    '& > *': {
      marginRight: 5
    }
  },
  modifyContainer: {
    flex: 1,
    borderLeft: '2px solid #dee2e6',
    padding: 15
  }
};

export const { classes } = jss.createStyleSheet(styles).attach();



// WEBPACK FOOTER //
// ./src/views/customer/styles/modify-tree.js